import React from 'react'

import { Container, Row, Col } from 'reactstrap'

import { Sudoku } from 'sdc-sudoku'

export default () => (
  <div>
    <p>Echaton arbeitet seit drei Jahrzehnten als Programmierer. Über die Jahre hat er außerdem mehr als 50 Lego-Modelle entworfen.</p>
    <Container>
      <Row>
        <Col><Sudoku className="sudoku-game" /></Col>
      </Row>
    </Container>
  </div>
)
